import { render, staticRenderFns } from "./printHistoriaEmbarazo.vue?vue&type=template&id=00ac18d0&scoped=true"
import script from "./printHistoriaEmbarazo.vue?vue&type=script&lang=js"
export * from "./printHistoriaEmbarazo.vue?vue&type=script&lang=js"
import style0 from "./printHistoriaEmbarazo.vue?vue&type=style&index=0&id=00ac18d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac18d0",
  null
  
)

export default component.exports